import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './FeaturedBrand.css';
import trustedBg from '../../assets/figma_trusted_bg.jpg';
import alphaImg from '../../assets/brand_alpha_house2.png';
import sofarImg from '../../assets/brand_sofar_house_trimmed.png';
import goodweImg from '../../assets/brand_growatt_house2.png';
import solaxImg from '../../assets/brand_solax_house2.png';
import thumbUp from '../../assets/figma_thumb_up.svg';

const brands = [
  {
    image: goodweImg,
    name: 'Growatt',
    tagline: 'Smart Home Energy Storage',
    details: [
      '6M+ end users connected globally across 180+ countries',
      'AI & IoT energy prediction with cloud monitoring',
      'Hybrid & off-grid ready with EV charger compatibility',
      'Dedicated local support with fast response times',
    ],
    link: '/contact',
  },
  {
    image: solaxImg,
    name: 'SolaX',
    tagline: 'Scalable LFP Battery Storage',
    details: [
      'Capacity from 2.5kWh up to 92.1kWh — grows with your needs',
      'LFP chemistry for enhanced safety and extended lifespan',
      'Retrofit compatible with existing string inverter systems',
      'Smart BMS protection against overcharging and thermal issues',
    ],
    link: '/contact',
  },
  {
    image: sofarImg,
    name: 'SOFAR PowerAll',
    tagline: 'All-In-One ESS',
    details: [
      'Ultra-Low Self-Consumption',
      'Battery and Electricity Separation and Ultimate Safety Design',
      'Full Power Fast Active Battery Balancing',
      'Integrated Auto-Switch for EPS',
    ],
    link: '/contact',
  },
  {
    image: alphaImg,
    name: 'Alpha ESS',
    tagline: "Australia's Proven Energy Storage Solution",
    details: [
      '10+ YEARS in the Australian market',
      'Australia-wide leader · No.1 in 2023',
      'Expandable battery system for growing families',
      'Backed by local manufacturer support and 10-year manufacturer warranty',
    ],
    link: '/contact',
  },
];

export default function FeaturedBrand() {
  const [current, setCurrent] = useState(0);
  const trackRef = useRef(null);

  const goTo = (i) => {
    setCurrent(i);
    const slide = trackRef.current?.children[i];
    if (slide) {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  };

  return (
    <section className="trusted-brands" style={{ backgroundImage: `url(${trustedBg})` }}>
      <div className="trusted-overlay" />
      <div className="trusted-inner">
        <h2 className="trusted-title">Trusted brands we work with</h2>
        <p className="trusted-subtitle">
          We partner with proven brands to deliver reliable, long-term energy solutions.
        </p>

        <div className="trusted-carousel-wrap">
          <div className="trusted-track" ref={trackRef}>
            {brands.map((brand, i) => (
              <div key={i} className="brand-slide">
                <div className="brand-card">
                  <div className="brand-card-img-wrap">
                    <img src={brand.image} alt={brand.name} className="brand-card-img" />
                  </div>
                  <div className="brand-card-body">
                    <h3 className="brand-card-name">{brand.name}</h3>
                    <p className="brand-card-tagline">{brand.tagline}</p>
                    <ul className="brand-card-details">
                      {brand.details.map((d, j) => (
                        <li key={j}>
                          <div className="brand-bullet-circle">
                            <img src={thumbUp} alt="" className="brand-bullet-icon" />
                          </div>
                          <span>{d}</span>
                        </li>
                      ))}
                    </ul>
                    <Link to={brand.link} className="brand-card-link">Get a free quote</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="trusted-dots">
          {brands.map((_, i) => (
            <button
              key={i}
              className={`trusted-dot${i === current ? ' active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Go to brand ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
